$(document).ready(function () {  
  /* ================= 반응형 체크 ============ */
  $(window).resize(function(){
    responsiveDevice();    /// pc, mobile 체크
    keyVisual();           /// keybisual( full )
    scrollHelpOnOff();     /// 스크롤 핼프 삭제
    hamburgerMenu();       /// 햄버거 
    languageMenu();        /// 다국어레이어
    console.log("==============reisze============")
  });

  /*  */
  function responsiveDevice(){ 
    var _change_width = window.innerWidth; //  $(window).innerWidth(); //
    var _temp_width;
    //console.log(_change_width)
    if( _change_width >= 1024){
        _temp_width = "is_pc";
    }else{
        _temp_width = "is_mb";
    };
    trpUtilityChangeOnceFN(_temp_width, function($chang){
        $("body").removeClass("is_pc is_mb");
        $("body").addClass($chang);

        $(".is_mb .js-hamburger-list .colitem .dep2-list").hide();  // 햄버거 서브 메뉴
        //console.log("===================== read =====================")
    });
  }
  responsiveDevice();



  /* ============================================= header > hamburger    */
  $(".js-hamburger-btn").on("click",function($e){
    $e.preventDefault();
    //$(".gnb-wrap").append(  $(".js-hamburger-con")  );
    $(".js-hamburger-list .colitem").removeClass("on");
    $(".js-hamburger-con").addClass("open");
    $("body").addClass("hamburger_open");
    
    // 언어 닫기
    $(".js-language_pack-con").removeClass("open");
  })
  $(".js-hamburger-con .hamburger_close-btn").on("click",function($e){
    $e.preventDefault();
    $(".js-hamburger-con").removeClass("open");
    $("body").removeClass("hamburger_open");
  })

  /* ============================================= header > language pack    */
  $(".lang_dropdown-area .dropdown-box").on("click", function($e){
    $e.preventDefault();
    //$(".gnb-wrap").append( $(".js-language_pack-con") );
    $(".js-language_pack-con").addClass("open");

    // 햄버거 닫기
    $(".js-hamburger-con").removeClass("open");
  })
  $(".js-language_pack-con .language_close-btn").on("click", function($e){
    $e.preventDefault();
    $(".js-language_pack-con").removeClass("open");
  });


  /* sub menu */
  $(".js-hamburger-list").trpAccordionMenu(".js-dep1" ,".dep2-list" , "on", function($index){
    //console.log(">>> "+ $index)
    return true;
  });
  function hamburgerMenu(){
    $(".is_pc .js-hamburger-list .colitem .dep2-list").show();
    $(".is_pc .js-hamburger-list .colitem").removeClass("on");

    //$(".is_mb .js-hamburger-list .colitem .dep2-list").hide();
  }
  

  /* ============================================= header > lang & location  */
  var location_dropdown = $(".location_dropdown-area .js-dropdown-btn").trpDropdown({ list : ".trp-dropdown_list-box" , area:".trp-dropdown-area"});
  $(".location_dropdown-area .trp-dropdown_list-box a").on("click", function(){
    var _this = $(this);
    _this.closest(".location_dropdown-area").find( ".select-btn span" ).text( _this.text() );
    location_dropdown.getClose();
  });


 
  /* sub language (버튼 , 컨테이너) */
  $(".js-language-list").trpAccordionMenu(".js-language" ,".language-list" , "on", function($index){
    //console.log(">>> "+ $index)
    return true;
  });
  function languageMenu(){
    $(".is_pc .js-language-list .colitem .language-list").show();
    $(".is_pc .js-language-list .colitem").removeClass("on");
  }







  /* ============================================= visual scroll */
  function trpScrollTop($selector, $add){
    var _position = $($selector).offset();
    $( 'html, body' ).animate( { scrollTop: _position.top + $add }, 500 );
  };
  $(".js-scroll_page1").on("click", function($e){ 
    $e.preventDefault();
    trpScrollTop("#scroll_page1" , 0 );
  })


  /* ================== kyvisual Full visual ====================== */
  function keyVisual(){
    if( $(".keyvisual-wrap .video-area").length ){
      trpFillLimitedFn(".keyvisual-wrap .video-area", ".keyvisual-wrap .youtube_player", 1280 , 720,  window.innerWidth,  window.innerHeight, -135, 0 );
    }
  }	
  keyVisual();


  /* ================== scroll X  help  ====================== */
  // 드래그 하면 아이콘 삭제
  $(".is_mb .responsive_scrollx").on("touchmove", function($e){ 
    $(this).removeClass("help_on"); 
  });
  function scrollHelpOnOff(){ 
    $(".is_pc .responsive_scrollx").removeClass("help_on");
    $(".is_mb .responsive_scrollx").each( function(){
      console.log("scrollssss")
      $(this).hasScrollBar(); // ture of false
    }) 
  }
  $.fn.hasScrollBar = function() { 
    // 스크롤 있는지 여부 판단
    var _B =  (this.prop("scrollWidth") == 0 && this.prop("clientWidth") == 0)
    || (this.prop("scrollWidth") > this.prop("clientWidth"));
    _B ? $(this).addClass("help_on") : $(this).removeClass("help_on");
    return _B
    
  };
  $(".is_mb .responsive_scrollx").hasScrollBar();
  
}); // resize 


/* ================== gllery_viewpage Fn  ====================== */
function gallery_viewpageFN($this, $t , $c ){
  var _t = $t;
  var _c = $c;
  var _p = $c / $t * 100 + "%";
  if( $t < 10 ){ _t = "0" + _t; }
  if( $c < 10 ){ _c = "0" + _c; }
  $(".progress_bar .bar", $this).css({ width: _p });
  $(".progress_count .current", $this).text(_c)
  $(".progress_count .total", $this).text(_t)
}


/* 특정위치로 스크롤 */
function trpScrollTop($selector ){
  var _position = ""; 
  if( $("body").hasClass("is_pc") ){
    _position = Number($($selector).offset().top - ($(".gnb-wrap").innerHeight()) - ($(".location-wrap").innerHeight()) - 10);  
  }else{
    _position = Number($($selector).offset().top - ($(".gnb-wrap").innerHeight()) - 10);  
  }

  ///메뉴높이 
  console.log(_position)
  $( 'html, body' ).animate( { scrollTop: _position }, 350 );
};
  
  

